import React from 'react';
import PropTypes from 'prop-types';
import { Async } from 'react-select';
import styled from 'styled-components';
import Highlighter from 'react-highlight-words';
import 'react-select/dist/react-select.css';

const StyledSelect = styled.div`
  .Select-menu-outer {
    max-height: 600px;
  }

  .Select-menu {
    max-height: 598px;
  }
`;

const StyledOption = styled.div`
  color: ${({ used, color }) => (used ? color : 'inherit')};
`;

class TagSelect extends React.Component {
  optionRenderer = option => {
    const { colors } = this.props;
    const values = this.props.currentTags;
    const used = values.find(t => t.value === option.value) !== null;
    const text = option.label;
    let unit = null;
    if (option.engunit) {
      unit = (
        <div style={{ float: 'right', textAlign: 'right' }}>
          <strong>[{option.engunit}]</strong>
        </div>
      );
    }
    return (
      <StyledOption used={used && colors} color={colors[option.value]}>
        {used && <i className="fa fa-fw fa-check" />}
        <Highlighter
          searchWords={this.inputVal
            .split(' ')
            .filter(e => e !== undefined && e.length > 0)}
          textToHighlight={text}
          autoEscape
        />
        {unit}
      </StyledOption>
    );
  };

  render() {
    const { loadOptions, onChange } = this.props;
    return (
      <StyledSelect>
        <Async
          name="tags"
          onInputChange={val => {
            this.inputVal = val;
          }}
          loadOptions={loadOptions}
          optionRenderer={this.optionRenderer}
          placeholder="Select a tag"
          cache={false}
          onChange={onChange}
          filterOptions={options => options}
          closeOnSelect={false}
          onSelectResetsInput={false}
          multi
        />
      </StyledSelect>
    );
  }
}

TagSelect.propTypes = {
  loadOptions: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  currentTags: PropTypes.array.isRequired,
  colors: PropTypes.objectOf(PropTypes.string),
};

TagSelect.defaultProps = {
  loadOptions: [],
  colors: {},
  removeTag: () => {},
};

export default TagSelect;



// WEBPACK FOOTER //
// ./src/components/TagSelect/TagSelect.js